// assets
import "./Section1.scss";
import "animate.css";

// code imports
import React, { useEffect, useState } from "react";
import Header from "../../common/Header/Header";
import { SOCIAL_LINKS } from "../../common/socialLinks";


function Section1({ style }) {
    const VIDEO_URL_MOBILE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/hero_video_mobile.mp4";
    const VIDEO_URL_DESKTOP = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/hero_video_desktop_final.webm";
    const APP_STORE_BADGE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/app_store_badge.png";
    const PLAY_STORE_BADGE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/play_store_badge_v1.png";
    const FALLBACK_BG = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/hero_image.png";

    const [videoReady, setVideoReady] = useState(false);
    const [videoFailed, setVideoFailed] = useState(false);
    // the video is over a MB and its first frame can become the LCP element, so start it only
    // after the page has finished loading (hero image + JS + CSS get the bandwidth first).
    const [loadVideo, setLoadVideo] = useState(false);
    useEffect(() => {
        // phones on a slow connection or with data saver on keep the poster image and skip the video
        const conn = navigator.connection;
        const constrained = window.matchMedia("(max-width: 767px)").matches &&
            conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || "") || conn.effectiveType === "3g");
        if (constrained) return undefined;
        let t;
        const start = () => { t = setTimeout(() => setLoadVideo(true), 1000); };
        if (document.readyState === "complete") start();
        else window.addEventListener("load", start, { once: true });
        return () => {
            clearTimeout(t);
            window.removeEventListener("load", start);
        };
    }, []);

    // each screen size gets its own video (re-evaluated if the window crosses the breakpoint)
    const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 767px)").matches);
    useEffect(() => {
        const mq = window.matchMedia("(max-width: 767px)");
        const onChange = (e) => {
            setIsMobile(e.matches);
            setVideoReady(false);
        };
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);
    const VIDEO_URL = isMobile ? VIDEO_URL_MOBILE : VIDEO_URL_DESKTOP;

    const styles = {
        backgroundImage: `url(${FALLBACK_BG})`,
        flex: 1,
        position: "relative",
        overflow: "hidden",
        ...style,
    };

    const bgVideo_styles = {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        zIndex: 0,

        opacity: videoReady && !videoFailed ? 1 : 0,
        transition: "opacity 250ms ease",
    };

    return (
        <div className="HomePage-Section1 HeroSection row" style={styles}>
            <div className="col-12 d-flex flex-column justify-content-start" style={{ position: "relative" }}>
                {loadVideo && !videoFailed && (
                    <video
                        key={VIDEO_URL}
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        style={bgVideo_styles}
                        onLoadedData={() => setVideoReady(true)}
                        onCanPlay={() => setVideoReady(true)}
                        onError={() => setVideoFailed(true)}
                    >
                        <source src={VIDEO_URL} type={VIDEO_URL.endsWith(".webm") ? "video/webm" : "video/mp4"} />
                    </video>
                )}
                {/* Content above video */}
                <div style={{ position: "relative", zIndex: 2 }}>
                    <Header variant="desktop" style={{ backgroundColor: "transparent", position: "absolute", top: 0, left: 0, width: "100%" }} />

                    <div className="InnerContent text-white pt-md-5 mt-md-5">
                        <div className="px-3 ps-md-5 animate__animated animate__fadeInLeft animate_delay-1s">
                            <h1 className="HeroHeading">
                                HITWICKET<sup className="HeroHeading-tm">&trade;</sup>
                                <br />CRICKET GAME
                                <br />2026
                            </h1>
                            <p className="HeroTagline">
                                Where <strong>fast-paced</strong> cricket meets <br /> <strong>competitive strategy</strong>
                            </p>

                            {/* desktop only: stacked store badges under the tagline (phones get them in the text section) */}
                            <div className="HeroStores animate__animated animate__fadeInUp animate_delay-1s">
                                <a href="https://app.adjust.com/1h9a99v0">
                                    <img src={PLAY_STORE_BADGE} alt="Get it on Google Play" />
                                </a>
                                <a href="https://app.adjust.com/1h9a99v0">
                                    <img src={APP_STORE_BADGE} alt="Download on the App Store" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* phones: store badges centred at the bottom of the hero */}
                <div className="HeroStoresMobile d-md-none">
                    <a href="https://app.adjust.com/1h9a99v0">
                        <img src={PLAY_STORE_BADGE} alt="Get it on Google Play" />
                    </a>
                    <a href="https://app.adjust.com/1h9a99v0">
                        <img src={APP_STORE_BADGE} alt="Download on the App Store" />
                    </a>
                </div>

                {/* social icons stacked down the right edge, on every screen size */}
                <div className="HeroSocialRail">
                    {SOCIAL_LINKS.map((s) => (
                        <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}>
                            <img src={s.icon} alt="" />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Section1;
